import { GentooGreetingView } from "./GentooView";
import styles from '../style/styles/Display.module.css';
import { useEffect, useState } from "react";
import { CarouselContainer } from "./Carousel/CarouselContainer";
import { CarouselContainerModal } from "./Carousel/CarouselContainerModal";
import { useChatStateStore, useUserStore } from "../zustand/store";
import { sendCloseRequestState } from "../utils/utils";
import { contents } from "../data/contents";
import { DisplayContentModeEnum, EnableModeEnum } from "../type/modeState.type"

const Display = (props) => {
    const { mode } = props;
    const { isFormSubmitted, isNewProduct, setIsNewProduct, newProductCount, enableMode, isPDPChat, setIsPDPChat, language } = useChatStateStore();
    const { isMobileDevice, partnerType } = useUserStore();
    const [isDisplayOpen, setIsDisplayOpen] = useState(isMobileDevice ? false : true);

    const getDisplayContent = () => {
        switch (mode) {
            case DisplayContentModeEnum.GREETING:
                return <GentooGreetingView isDisplayOpen={isDisplayOpen} />;
            case DisplayContentModeEnum.PRODUCT_SINGLE:
                return <CarouselContainer isDisplayOpen={isDisplayOpen} type={'single'} />;
            case DisplayContentModeEnum.PRODUCT_HORIZONTAL_LIST:
                return <CarouselContainer isDisplayOpen={isDisplayOpen} type={'horizontal'} />;
            case DisplayContentModeEnum.PRODUCT_VERTICAL_LIST:
                return <CarouselContainer isDisplayOpen={isDisplayOpen} type={'vertical'} />;
            case DisplayContentModeEnum.SIMPLE_LIST:
                return <CarouselContainerModal isDisplayOpen={true} type={'vertical'} />;
            default:
                return <GentooGreetingView isDisplayOpen={isDisplayOpen} />;
        }
    }

    useEffect(() => {
        if (partnerType === 'fastfive') {
            if (isFormSubmitted === 'ready') {
                setIsDisplayOpen(false);
            } else if (isFormSubmitted === 'submitted') {
                setIsDisplayOpen(true);
            }
        }
    }, [isFormSubmitted]);

    useEffect(() => {
        if (enableMode === EnableModeEnum.FULL) {
            setIsDisplayOpen(true);
        } else if (enableMode === EnableModeEnum.SHRINK) {
            setIsDisplayOpen(false);
        }
    }, [enableMode]);

    useEffect(() => {
        const handleUserInteraction = () => {
            setIsNewProduct(false);
            setIsPDPChat(false);
        };

        if (isNewProduct) {
            document.addEventListener('click', handleUserInteraction);
            document.addEventListener('touchstart', handleUserInteraction);
            document.addEventListener('keydown', handleUserInteraction);
        }

        return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('touchstart', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
        };
    }, [isNewProduct]);

    useEffect(() => {
        let startY = 0;
        let isDragging = false;

        const handleTouchStart = (e) => {
            startY = e.touches[0].clientY;
            isDragging = true;
        };

        const handleTouchMove = (e) => {
            if (!isDragging) return;
            const currentY = e.touches[0].clientY;
            const diffY = currentY - startY;

            if (diffY > 80) { // Threshold for detecting a downward drag
                sendCloseRequestState(true);
                // Add your logic here for what should happen on a downward drag
                isDragging = false; // Reset dragging state
            }
        };

        const handleTouchEnd = () => {
            isDragging = false;
        };

        const displayElement = document.querySelector(`.${styles.Display__Container}`);
        displayElement.addEventListener('touchstart', handleTouchStart);
        displayElement.addEventListener('touchmove', handleTouchMove);
        displayElement.addEventListener('touchend', handleTouchEnd);

        return () => {
            displayElement.removeEventListener('touchstart', handleTouchStart);
            displayElement.removeEventListener('touchmove', handleTouchMove);
            displayElement.removeEventListener('touchend', handleTouchEnd);
        };
    }, [styles.Display__Container]);

    return (
        <div className={styles.Display__Container}>
            <div className={mode === DisplayContentModeEnum.GREETING ? styles.TopHeader__container__loading : styles.TopHeader__container}>
                <div className={styles.TopHeader__divider} />
            </div>
            {getDisplayContent()}
            <div className={styles.Display__CarouselAlarmBadge} style={{ visibility: isNewProduct ? 'visible' : 'hidden' }}>
                <div className={styles.Display__CarouselAlarmBadge__Body}>
                    {
                        isPDPChat ?
                        <p className='h10 fc-white'>{contents.display[language].newProduct}</p>
                        :
                        <p className='h10 fc-white'>{contents.display[language].newProductCount}{newProductCount}</p>
                    }
                </div>
                <div className={styles.Display__CarouselAlarmBadge__Bottom}/>
            </div>
        </div>
    )
}

export default Display;